import { Trans, useTranslation } from 'react-i18next'

import { Plus16, Trash16 } from '@makyoapp/makyo-icon/icon'
import { Button, ButtonVariant } from '@makyoapp/makyo-ui'

import { useAppPagesContext } from '@/context/AppPagesContext'

import { ScreenDropdownV2 } from './ScreenDropdownV2'

function Item({
  id,
  label,
  value,
  values,
  onChange,
}: {
  id: string
  label?: string
  value?: string
  values: string[]
  onChange?: (next: string[]) => void
}) {
  return (
    <div className='flex-c w-full'>
      <div className='flex-c4 w-full'>
        <div>{label}</div>
        <ScreenDropdownV2
          value={value}
          onChange={(next) => {
            const copy = [...values]
            copy[Number(id)] = next as string
            onChange?.(copy)
          }}
        />
      </div>
      <div className='flex'>
        <Button
          variant={ButtonVariant.Ghost}
          squared
          noPadding
          icon={<Trash16 />}
          onClick={() => {
            onChange?.(values.filter((v, i) => i !== Number(id)))
          }}
        />
      </div>
    </div>
  )
}

export interface ScreenRepeaterProps {
  id?: string
  label?: string
  values?: string[]
  onChange?: (nextValues: string[]) => void
}

export function ScreenRepeaterV2({ values = [], label, onChange, id }: ScreenRepeaterProps) {
  const { pages, activePageIndex } = useAppPagesContext()
  const { t } = useTranslation()

  function getPageId(index = 0): string | undefined {
    if (pages[index]?.id) {
      if (index === activePageIndex) {
        return getPageId(index + 1)
      } else {
        return pages[index]?.id
      }
    }

    return undefined
  }

  return (
    <div id={id} className='flex flex-col gap-4 w-full'>
      {values.length > 0 && (
        <div className='flex flex-col gap-2 w-full'>
          {values.map((value, i) => {
            return (
              <Item
                label={t(`${label} ${i + 1}`)}
                key={i}
                value={value}
                values={values}
                onChange={onChange}
                id={i.toString()}
              />
            )
          })}
        </div>
      )}
      <button
        className='w-full border border-dashed bdr flex-cc h-10 p-2 rounded-md bg-zinc-200 hover:bg-zinc-300 dark:bg-slate-900 dark:hover:bg-slate-700'
        onClick={() => {
          const pid = getPageId()
          onChange?.([...values, pid as string])
        }}
      >
        <Plus16 />
        <Trans>Add {label}</Trans>
      </button>
    </div>
  )
}
